module.exports = __webpack_public_path__ + "media/images/xpass/studio-featured-eb95df3fd6fd8f935e5ae04034e63987.svg";